import { Button, Group, Loader, Modal } from "@mantine/core";

import { TextWrapper } from "../TextWrapper";

interface RemovalConfirmationModalProps {
  title: string;
  itemId: string;
  description: string;
  actionText: string;
  isOpen: boolean;
  handleClose: () => void;
  handleAction: () => void;
  isDeleting?: boolean;
}

export default function RemovalConfirmationModal({
  title,
  itemId,
  description,
  actionText,
  isOpen,
  handleClose,
  handleAction,
  isDeleting,
}: RemovalConfirmationModalProps) {
  const prefix = `removal-confirmation-modal-${itemId}`;

  return (
    <Modal
      centered
      opened={isOpen}
      data-testid={prefix}
      onClose={handleClose}
      title={
        <TextWrapper fz={18} ta="left" variant="bold" data-testid={`${prefix}-title`}>
          {title}
        </TextWrapper>
      }
    >
      <Group justify="flex-start">
        <TextWrapper mt={1} mb={1} mr={40} ta="left" data-testid={`${prefix}-description`}>
          {description}
        </TextWrapper>
      </Group>
      <Group mt={11} justify="flex-end">
        <Button
          variant="outline"
          color="burgundy.9"
          onClick={handleClose}
          data-testid={`${prefix}-cancel`}
        >
          Cancel
        </Button>
        <Button
          color="red.7"
          disabled={isDeleting}
          onClick={handleAction}
          aria-label={`${prefix}-ok`}
          data-testid={`${prefix}-action`}
        >
          {isDeleting ? <Loader size="sm" color="white" /> : actionText}
        </Button>
      </Group>
    </Modal>
  );
}
